import { FilterList } from "@amzn/stencil-react-components/filtering";
import { View } from "@amzn/stencil-react-components/layout";
import React, { FC } from "react";

import { AiToolsNavigationLink } from "./AiToolsNavigationLink";

export interface CategoryFilterListProps {
  titleText: string;
  resetButtonText: string;
  isMulti: boolean;
  options: Array<{ label: string; value: string }>;
  value: string[] | undefined;
}

export const CategoryFilterList: FC<CategoryFilterListProps> = ({
  titleText,
  resetButtonText,
  isMulti,
  options,
  value,
}) => {
  // Split options into AI tools link and regular categories
  const aiToolsOptions = options.filter((option) => option.value === "aiforme-link");
  const regularOptions = options.filter((option) => option.value !== "aiforme-link");

  return (
    <View>
      {/* AI Tools navigation link */}
      {aiToolsOptions.length > 0 && <AiToolsNavigationLink />}

      {/* Regular category filter */}
      <FilterList
        titleText={titleText}
        resetButtonText={resetButtonText}
        isMulti={isMulti}
        options={regularOptions}
        value={value}
      />
    </View>
  );
};
